// extracted by mini-css-extract-plugin
module.exports = {"Quiz":"Quiz__Quiz___guFF3","QuizWrapper":"Quiz__QuizWrapper___3Hy2q"};